/*
 * File: number-helper.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-12-23 05:54:05
 * Modified By: Val Liu
 * -----
 */

export class NumberHelper {
    static toFixedNumber(num: number, digits: number, base: number = 10) {
        var pow = Math.pow(base, digits);
        return Math.round(num * pow) / pow;
    }

    static toString(num: number | undefined): string | null {
        if (num == undefined || isNaN(num)) return null;
        return String(num);
    }

    /// a function to make number ex: 10000000, to: 10,000,000
    static toPrettyString(num: number, options?: Intl.NumberFormatOptions): string {
        return num.toLocaleString("en-US", options);
    }

    /// auto transform to make the output more readible, B / KB / M / G / T, precise to 3 decimal places.
    /// also make 1000 to 1,000
    static toPrettyBytes(num: number): string {
        if (num < 0) return `-${this.toPrettyBytes(-num)}`; // Handle negative numbers

        const units = ["B", "KB", "MB", "GB", "TB"];
        let unitIndex = 0;

        while (num >= 1024 && unitIndex < units.length - 1) {
            num /= 1024;
            unitIndex++;
        }

        return `${this.toFixedNumber(num, 3).toLocaleString()} ${units[unitIndex]}`;
    }
}
